
export default (values) => {
    let errors = {};

    if (!values.documentType) {
        errors.documentType = 'Complete el tipo de documento';
    }
    return errors;
};
